import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function PoliciesPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <WhatsAppButton />

      {/* Hero Section */}
      <section className="relative h-80 flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://sunandspeed.com/wp-content/uploads/2025/04/7.webp"
            alt="Policies"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70"></div>
        </div>
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4">
            Políticas y <span className="text-amber-400">Términos</span>
          </h1>
          <p className="text-xl text-gray-300">
            Información importante sobre nuestros servicios
          </p>
        </div>
      </section>

      {/* Quick Navigation */}
      <section className="bg-gray-900 py-6 sticky top-20 z-40 border-b border-amber-900/30">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="#alquiler"
              className="px-6 py-2 bg-amber-500/20 text-amber-400 rounded-full hover:bg-amber-500/30 transition-all text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Política de Alquiler
            </a>
            <a
              href="#cancelacion"
              className="px-6 py-2 bg-amber-500/20 text-amber-400 rounded-full hover:bg-amber-500/30 transition-all text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Cancelaciones
            </a>
            <a
              href="#privacidad"
              className="px-6 py-2 bg-amber-500/20 text-amber-400 rounded-full hover:bg-amber-500/30 transition-all text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Privacidad
            </a>
            <a
              href="#terminos"
              className="px-6 py-2 bg-amber-500/20 text-amber-400 rounded-full hover:bg-amber-500/30 transition-all text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Términos y Condiciones
            </a>
            <a
              href="#seguros"
              className="px-6 py-2 bg-amber-500/20 text-amber-400 rounded-full hover:bg-amber-500/30 transition-all text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Seguros
            </a>
          </div>
        </div>
      </section>

      <div className="py-16 bg-black">
        <div className="max-w-4xl mx-auto px-4 space-y-16">
          {/* Política de Alquiler */}
          <section id="alquiler" className="scroll-mt-32">
            <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center">
                  <i className="ri-file-text-line text-2xl text-amber-400"></i>
                </div>
                <h2 className="text-3xl font-bold text-white">Política de Alquiler</h2>
              </div>

              <div className="space-y-6 text-gray-300">
                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Requisitos del Conductor</h3>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Edad mínima: 25 años</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Licencia de conducir válida con al menos 3 años de antigüedad</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Identificación oficial vigente (pasaporte o INE/IFE)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Tarjeta de crédito a nombre del conductor principal</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Comprobante de domicilio no mayor a 3 meses</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Depósito de Seguridad</h3>
                  <p className="mb-2">
                    Se requiere un depósito de seguridad reembolsable que varía según el vehículo:
                  </p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Vehículos hasta $1,000/día: $5,000 USD</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Vehículos de $1,000 - $1,500/día: $10,000 USD</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Vehículos de $1,500+/día: $15,000 USD</span>
                    </li>
                  </ul>
                  <p className="mt-3 text-sm text-gray-400">
                    El depósito se reembolsa dentro de 7-14 días hábiles después de la devolución del vehículo, 
                    sujeto a inspección y sin daños.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Combustible</h3>
                  <p>
                    Todos los vehículos se entregan con el tanque lleno y deben devolverse con el tanque lleno. 
                    En caso contrario, se cobrará el combustible faltante más un cargo por servicio de $50 USD.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Kilometraje</h3>
                  <p>
                    Todos nuestros alquileres incluyen kilometraje ilimitado dentro del territorio acordado 
                    (México o Estados Unidos según corresponda).
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Conductores Adicionales</h3>
                  <p className="mb-2">
                    Se pueden agregar conductores adicionales por $25 USD por día. Cada conductor adicional 
                    debe cumplir con los mismos requisitos que el conductor principal y estar presente al 
                    momento de la recogida del vehículo.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Política de Cancelación */}
          <section id="cancelacion" className="scroll-mt-32">
            <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center">
                  <i className="ri-close-circle-line text-2xl text-amber-400"></i>
                </div>
                <h2 className="text-3xl font-bold text-white">Política de Cancelación</h2>
              </div>

              <div className="space-y-6 text-gray-300">
                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Cancelación por el Cliente</h3>
                  <ul className="space-y-3">
                    <li className="bg-black/50 p-4 rounded-lg">
                      <div className="flex items-start gap-3">
                        <i className="ri-time-line text-amber-400 text-xl mt-1"></i>
                        <div>
                          <p className="font-semibold text-white mb-1">Más de 7 días antes</p>
                          <p className="text-sm">Reembolso del 100% del monto pagado</p>
                        </div>
                      </div>
                    </li>
                    <li className="bg-black/50 p-4 rounded-lg">
                      <div className="flex items-start gap-3">
                        <i className="ri-time-line text-amber-400 text-xl mt-1"></i>
                        <div>
                          <p className="font-semibold text-white mb-1">Entre 3-7 días antes</p>
                          <p className="text-sm">Reembolso del 50% del monto pagado</p>
                        </div>
                      </div>
                    </li>
                    <li className="bg-black/50 p-4 rounded-lg">
                      <div className="flex items-start gap-3">
                        <i className="ri-time-line text-amber-400 text-xl mt-1"></i>
                        <div>
                          <p className="font-semibold text-white mb-1">Menos de 3 días antes</p>
                          <p className="text-sm">Sin reembolso</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Modificaciones de Reserva</h3>
                  <p className="mb-2">
                    Las modificaciones de fechas están sujetas a disponibilidad y pueden incurrir en cargos adicionales:
                  </p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Primera modificación: Sin cargo (más de 48 horas antes)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Modificaciones adicionales: $50 USD por cambio</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Cambios de vehículo: Sujeto a diferencia de precio</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">No Show (No Presentarse)</h3>
                  <p>
                    Si el cliente no se presenta a recoger el vehículo sin cancelación previa, 
                    no habrá reembolso del monto pagado.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Política de Privacidad */}
          <section id="privacidad" className="scroll-mt-32">
            <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-amber-400"></i>
                </div>
                <h2 className="text-3xl font-bold text-white">Política de Privacidad</h2>
              </div>

              <div className="space-y-6 text-gray-300">
                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Recopilación de Información</h3>
                  <p className="mb-2">Recopilamos la siguiente información personal:</p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Nombre completo, dirección y datos de contacto</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Información de licencia de conducir</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Información de pago y facturación</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Historial de alquileres y preferencias</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Uso de la Información</h3>
                  <p className="mb-2">Utilizamos su información para:</p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Procesar y gestionar sus reservas</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Comunicarnos con usted sobre su alquiler</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Mejorar nuestros servicios</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Enviar ofertas y promociones (con su consentimiento)</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Protección de Datos</h3>
                  <p>
                    Implementamos medidas de seguridad técnicas y organizativas para proteger su información 
                    personal contra acceso no autorizado, pérdida o alteración. Todos los datos de pago se 
                    procesan a través de pasarelas de pago seguras y encriptadas.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Sus Derechos</h3>
                  <p className="mb-2">Usted tiene derecho a:</p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Acceder a su información personal</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Solicitar corrección de datos inexactos</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Solicitar la eliminación de sus datos</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Oponerse al procesamiento de sus datos</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Términos y Condiciones */}
          <section id="terminos" className="scroll-mt-32">
            <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center">
                  <i className="ri-file-list-line text-2xl text-amber-400"></i>
                </div>
                <h2 className="text-3xl font-bold text-white">Términos y Condiciones</h2>
              </div>

              <div className="space-y-6 text-gray-300">
                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Responsabilidad del Arrendatario</h3>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Mantener el vehículo en buenas condiciones</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Cumplir con todas las leyes de tránsito</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>No conducir bajo influencia de alcohol o drogas</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>No participar en carreras o competencias</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>No subarrendar el vehículo</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Uso Prohibido</h3>
                  <p className="mb-2">El vehículo NO puede ser utilizado para:</p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Transporte comercial o de pasajeros</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Remolcar otros vehículos</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Conducción en caminos no pavimentados</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Actividades ilegales</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Cruzar fronteras internacionales sin autorización</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Daños y Accidentes</h3>
                  <p className="mb-2">
                    En caso de accidente o daño al vehículo:
                  </p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Notificar inmediatamente a Sun & Speed (24/7)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Obtener un reporte policial si es necesario</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>No admitir culpabilidad en el lugar</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Documentar el incidente con fotos</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Completar el reporte de accidente proporcionado</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Multas e Infracciones</h3>
                  <p>
                    El arrendatario es responsable de todas las multas, infracciones de tránsito, 
                    peajes y cargos por estacionamiento incurridos durante el período de alquiler. 
                    Se cobrará un cargo administrativo de $50 USD por cada infracción procesada.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Devolución del Vehículo</h3>
                  <p className="mb-2">
                    El vehículo debe devolverse:
                  </p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>En la fecha y hora acordadas</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>En la ubicación especificada</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Con el tanque lleno de combustible</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>En las mismas condiciones que fue entregado</span>
                    </li>
                  </ul>
                  <p className="mt-3 text-sm text-gray-400">
                    Las devoluciones tardías se cobrarán a razón de $100 USD por hora de retraso.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Seguros y Garantías */}
          <section id="seguros" className="scroll-mt-32">
            <div className="bg-gray-900 rounded-2xl p-8 border border-amber-900/30">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center">
                  <i className="ri-shield-star-line text-2xl text-amber-400"></i>
                </div>
                <h2 className="text-3xl font-bold text-white">Seguros y Garantías</h2>
              </div>

              <div className="space-y-6 text-gray-300">
                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Cobertura Incluida</h3>
                  <p className="mb-3">Todos nuestros alquileres incluyen:</p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-400 mt-1"></i>
                      <span>Seguro de responsabilidad civil ($1,000,000 USD)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-400 mt-1"></i>
                      <span>Seguro contra daños por colisión (CDW)</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-400 mt-1"></i>
                      <span>Protección contra robo</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill text-green-400 mt-1"></i>
                      <span>Asistencia en carretera 24/7</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Deducible</h3>
                  <p className="mb-2">
                    En caso de daño o robo, el arrendatario es responsable del deducible:
                  </p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Daños menores: $2,500 USD</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Daños mayores: $5,000 USD</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-amber-400 mt-1"></i>
                      <span>Pérdida total o robo: $10,000 USD</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Cobertura Adicional Opcional</h3>
                  <div className="space-y-3">
                    <div className="bg-black/50 p-4 rounded-lg">
                      <p className="font-semibold text-white mb-2">Protección Premium (Deducible Cero)</p>
                      <p className="text-sm mb-2">Elimina completamente el deducible en caso de daños</p>
                      <p className="text-amber-400 font-bold">$75 USD por día</p>
                    </div>
                    <div className="bg-black/50 p-4 rounded-lg">
                      <p className="font-semibold text-white mb-2">Seguro de Neumáticos y Cristales</p>
                      <p className="text-sm mb-2">Cubre daños a neumáticos, llantas y cristales</p>
                      <p className="text-amber-400 font-bold">$25 USD por día</p>
                    </div>
                    <div className="bg-black/50 p-4 rounded-lg">
                      <p className="font-semibold text-white mb-2">Protección de Efectos Personales</p>
                      <p className="text-sm mb-2">Cubre pérdida o robo de pertenencias personales</p>
                      <p className="text-amber-400 font-bold">$15 USD por día</p>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-amber-400 mb-3">Exclusiones</h3>
                  <p className="mb-2">El seguro NO cubre:</p>
                  <ul className="space-y-2 ml-6">
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Daños causados por conducción imprudente o negligente</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Daños bajo influencia de alcohol o drogas</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Uso no autorizado del vehículo</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Daños intencionales</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-close-line text-red-400 mt-1"></i>
                      <span>Pérdida de llaves o documentos</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="bg-gradient-to-br from-amber-900/20 to-amber-800/10 rounded-2xl p-8 border border-amber-700/30">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-white mb-4">
                ¿Tienes Preguntas?
              </h3>
              <p className="text-gray-300 mb-6">
                Nuestro equipo está disponible 24/7 para ayudarte con cualquier duda
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="/contacto"
                  className="bg-gradient-to-r from-amber-500 to-amber-600 text-black px-8 py-3 rounded-full font-bold hover:from-amber-600 hover:to-amber-700 transition-all whitespace-nowrap cursor-pointer"
                >
                  Contactar
                </a>
                <a
                  href="https://wa.me/522291578562?text=Hola!%20Revis%C3%A9%20las%20pol%C3%ADticas%20de%20VIP%20Luxury%20Cars%20MKS%20en%20su%20sitio%20web%20y%20tengo%20algunas%20preguntas.%20%C2%BFPueden%20ayudarme%3F"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 text-white px-8 py-3 rounded-full font-bold hover:bg-green-600 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}